import { Grid, Stack, Typography } from '@mui/material'
import HeadingTitle from 'components/dashboard-menu/HeadingTitle'

const CreateGuaranteeHeader = ({ label }) => {
  return (
    <Grid item xs={12}>
      <Stack direction="row" spacing={1} sx={{ paddingBottom: '2rem' }}>
        <HeadingTitle>{label}</HeadingTitle>
      </Stack>
    </Grid>
  )
}

export default CreateGuaranteeHeader
